import axios from 'axios';

export default axios.create({
  baseURL: 'https://api.softsa.com.br',
  // validateStatus: (status) => status < 500,
});
